// Build a safe onsubmit confirm() attribute (MT-051): JSON.stringify makes the
// message a valid JS string literal (quotes in record names included), and the
// handler is then entity-escaped for the HTML-attribute context.
function confirmSubmitAttr(message) {
    var js = 'return confirm(' + JSON.stringify(String(message)) + ');';
    return 'onsubmit="' + js.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;') + '"';
}

import dt from 'datatables.net-bs5';
import 'datatables.net-responsive-bs5';
// Fancy popups
import Swal from 'sweetalert2'
function toggle(className, displayState){
    var elements = document.getElementsByClassName(className);
    for (var i = 0; i < elements.length; i++){
        elements[i].style.display = displayState;
    }
}

document.addEventListener('DOMContentLoaded', function() {
/** 
   * Generic user datatable configuration for events table /events
   */
  if(document.getElementsByClassName('hfs-data-event-table').length > 0){

    if(document.getElementsByClassName('hfs-data-event-table')[0].dataset.archive){
      
        var archive = true;
        var archiveStr = '?archive=true';
        var columns = [
            { 
            data: 'name',
            render: function(data, type, row) {
                return eventName(data, type, row);
            },
            className: 'align-middle'
            },
            { 
            data: 'actions', 
            render: function(data, type, row){
                return eventArchiveButtons(data, type, row);
            },
            className: 'align-middle text-end'
            },
        ];

    }else{

        var archive = false;
        var archiveStr = '';

        var columns = [
        { 
            data: 'name',
            render: function(data, type, row) {
            return eventName(data, type, row);
            },
            className: 'align-middle'
        },
        { 
            data: 'start_datetime',
            className: 'align-middle',
            width: 150
        },
        { 
            data: 'end_datetime',
            className: 'align-middle',
            width: 150
        },
        { 
            data: 'enabled', 
            render: function(a,b,c){
                return eventEnabled(a,b,c);
            },
            className: 'align-middle text-center',
            width: 80
        },
        { 
            data: 'rsvp_count',
            className: 'align-middle',
            width: 100,
            render: function(data, b, row) {
              if(row.attendee_limit == null) {
                return data;
              }else{
                return data+'/'+row.attendee_limit;
              }
            }
        },
        { 
            data: 'req_feedback', 
            render: function(a,b,c){
                return reqFeedback(a,b,c);
            },
            className: 'align-middle text-center',
            width: 120
        },
        { 
            data: 'actions', 
            render: function(data, type, row){
            return eventButtons(data, type, row);
            },
            className: 'align-middle text-end',
            width: 450
        },
        ];

    }

    function eventButtons(data, display, row){

      var token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
      if(row.add_report && row.req_feedback == 1) {
        var eventReportBtn = `<a href="/events/`+row.id+`/edit#reportSection" class="btn btn-outline-success btn-sm" title="Add Post Event Report">
        <i class="fa fa-plus fa-fw"></i> Add Report
      </a>`;
      }else{
        var eventReportBtn = '';
      }

      var archiveEvtBtn = `<form method="POST" action="/events/`+row.id+`" accept-charset="UTF-8" `+confirmSubmitAttr('Do you really want to archive the event ' + row.name + '?')+`>
        <input name="_method" type="hidden" value="DELETE">
        <input name="_token" type="hidden" value="`+token+`">
          <button type="submit" class="btn btn-outline-danger hfs-btn-table-delete btn-sm">
            <i class="fa fa-trash fa-fw"></i> Archive
          </button>
        </form>`;

      var btnHTML = `
      <div class="btn-group">
        ${eventReportBtn}
        <a href="/events/`+row.id+`" class="btn btn-outline-secondary btn-sm" title="Show event">
          <i class="fa fa-eye fa-fw"></i> Show
        </a>
        <a href="/events/`+row.id+`/edit" class="btn btn-outline-secondary btn-sm" title="Edit event">
          <i class="fa fa-pencil fa-fw"></i> Edit
        </a>
        ${archiveEvtBtn}
      </div>`;
      
      return btnHTML;

    };

    function eventArchiveButtons(data, display, row){
      
      var token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

      var btnHTML = `
      <div class="btn-group">
        <form method="POST" action="/events/archive/restore" accept-charset="UTF-8" `+confirmSubmitAttr('Do you really want to restore the event ' + row.name + '?')+`>
        <input name="_method" value="DELETE" type="hidden" />
        <input name="restore_id" type="hidden" value="`+row.id+`">
        <input name="_token" type="hidden" value="`+token+`">

          <button type="submit" class="btn btn-outline-danger  btn-sm">
            <i class="fa-solid fa-trash-arrow-up fa-fw"></i> Restore
          </button>
        </form>
      </div>`;
      
      return btnHTML;

    };

    function eventName(data,display,row){

      if(row.event_type == 'property') {
        var evtClass = 'tbl-leftborder-primary';
      }else{
        var evtClass = 'tbl-leftborder-secondary';
      }

      var eventHTML = `
      <div class="d-flex px-2 py-1 ${evtClass}">
        <div>`;
        if(!row.image_url){
          eventHTML += `<img class="avatar avatar-sm me-3" src="/assets/img/placeholder.webp">`;
        }else{
          eventHTML += `<img class="avatar avatar-sm me-3" src="`+row.image_url+`">`;
        }
      eventHTML += `
        </div>
        <div class="d-flex flex-column justify-content-center">
          <h6 class="mb-0 text-xs">`+row.name+`</h6>
        </div>
      </div>`;

      return eventHTML;
    };

    function eventEnabled(data,b,c){

      var enabled = `
      <a href="javascript: void(0)" class="toggle-record" 
        data-table="events" 
        data-id="`+c.id+`" 
        data-column="enabled">`;

      if(data === 1){
        enabled += '<span class="badge text-light rounded-pill bg-success"><i class="fa fa-check fa-fw"></i></span>';
      }else{
        enabled += '<span class="badge bg-danger rounded-pill"><i class="fa fa-remove fa-fw"></i></span>';
      }

      enabled += `</a>`;
      return enabled;
    };

    function reqFeedback(data, b, c) {

      var enabled = `
      <a href="javascript: void(0)" class="toggle-record" 
        data-table="events" 
        data-id="`+c.id+`" 
        data-column="request_feedback">`;

      if(data === 1){
        enabled += `<span class="badge text-light rounded-pill bg-success"><i class="fa fa-check fa-fw"></i></span>`;
      }else{
        enabled += `<span class="badge bg-danger rounded-pill"><i class="fa fa-remove fa-fw"></i></span>`;
      }

      enabled += `</a>`;

      return enabled;
    }

    let table = new dt('.hfs-data-event-table', {
      // processing: true,
      serverSide: true,
      lengthMenu: [ [10, 25, 50, -1], [10, 25, 50, "All"] ],
      columns: columns,
      rowId: 'id',
      order: [[ 1, 'desc' ]],
      ajax: {
        url: '/events/ajax/json'+archiveStr,
        data: function(d) {
          var dateFrom = document.getElementById('filterDateFrom');
          var dateTo = document.getElementById('filterDateTo');
          var status = document.getElementById('filterStatus');
          var eventType = document.getElementById('filterEventType');
          if (dateFrom && dateFrom.value) d.dateFrom = dateFrom.value;
          if (dateTo && dateTo.value) d.dateTo = dateTo.value;
          if (status && status.value) d.status = status.value;
          if (eventType && eventType.value) d.eventType = eventType.value;
        }
      },
      "autoWidth": false,
      "responsive": {
        details: {
            type: 'column',
            target: 'tr'
        }
      },
      "initComplete": function(settings, json) {
          toggle('hfs-spinner', 'none');
          toggle('hfs-table', 'table');
          toggle('hfs-card-nav', 'flex');
      }
    });

    // Reload table when filters change
    document.querySelectorAll('#filterDateFrom, #filterDateTo, #filterStatus, #filterEventType').forEach(function(el) {
      el.addEventListener('change', function() { table.ajax.reload(); });
    });

  }

  $('#repeat_event').on('change', function(e){
      if($('#repeat_event').is(':checked')) {
          $('.recurring-repeat-options').show();
      }else{
          $('.recurring-repeat-options').hide();
      }
  });

  $('.btn-delete-existing-event-image').on('click', function(e){

    if(confirm('Are you sure you want to delete this event image?')){
      let imageId = $(this).data('image-id');
      let thisEel = $(this);

      $.ajax({
        url: '/events/deleteImage', 
        method: 'POST',
        data: {
          image_id: imageId,
          _token: document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        },
        success: function(response) {

          if(response.success){
            thisEel.parent().remove(); // remove li item..
          }
        }
      })
    }
  });

  $('#event_type').on('change', function(){
    
    $('.form-check-themed-primary-secondary .form-check-label').removeClass('active-secondary active-primary');

    if($(this).is(':checked')){
      $('.events-hide-web-address').show();
      $('.form-check-themed-primary-secondary .form-check-label.secondary').addClass('active-secondary');
    }else{

      $('.events-hide-web-address').find('.form-control').val('');
      $('.events-hide-web-address').hide();
      
      $('.form-check-themed-primary-secondary .form-check-label.primary').addClass('active-primary');
    }
  });

  $('#enabled_type').on('change', function(){
    
    $('.form-check-themed-enabled .form-check-label').removeClass('active-secondary active-primary');

    if($(this).is(':checked')){
      $('.form-check-themed-enabled .form-check-label.secondary').addClass('active-secondary');
    }else{
      $('.form-check-themed-enabled .form-check-label.primary').addClass('active-primary');
    }
  })

  $('.form-draft-events').on('change', function(){
    if( $(this).is(':checked') ) {
      $('.event-btn-text').text('Save Event');
    }else{
      $('.event-btn-text').text('Save Draft');
    }
  })

  $('.btn-save-event').on('click', function(e){

    e.preventDefault();

    // Client-side validation — prevent server round-trip that loses Dropzone state
    var errors = [];
    if(!$('input[name="name"]').val().trim()) errors.push('Name is required.');
    if(!$('textarea[name="description"]').val().trim()) errors.push('Description is required.');
    if(!$('input[name="start_datetime"]').val().trim()) errors.push('Start Date/Time is required.');
    if(!$('input[name="end_datetime"]').val().trim()) errors.push('End Date/Time is required.');
    if(!$('select[name="location"]').val()) errors.push('Location is required.');

    if(errors.length > 0) {
      Swal.fire({
        icon: 'error',
        title: 'Please fix the following:',
        html: '<ul style="text-align:left;margin:0;padding-left:20px;">' + errors.map(function(e){ return '<li>' + e + '</li>'; }).join('') + '</ul>',
      });
      return;
    }

    let gallerySelected  =  $('input[name^="gallery_image_id"]').length;
    let uploadedSelected = $('input[name^="image_files"]').length;
    let currentAssigned  = $('input[name^="assigned_images_ids"]').length;

    if(gallerySelected == 0 && uploadedSelected == 0 && currentAssigned == 0) {

      Swal.fire({
        icon: 'info',
        title: 'Are you sure you want to save the event without a image?',
        text: 'Selecting a image for your event will lead to more interaction.',
        showDenyButton: false,
        showCancelButton: true,
        confirmButtonText: 'Save without Image',
      }).then((result) => {

        if (result.isConfirmed) {
          $('#eventForm').submit();
        }

      });

    }else{
      // submit form as standard
      $('#eventForm').submit();
    }

  });

});